import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import * as uiActions from '~actions/ui-actions';

import Router from './router';
import { getStore } from './store';

import '../node_modules/rs-styles/cloud-mechanic/cloud-mechanic.css';

const store = getStore();
store.dispatch(uiActions.initialize());

ReactDOM.render(
  <Provider store={store}>
    <Router />
  </Provider>,
  document.getElementById('root')
);

